export class ControleEstoqueResumoStruct {
  disponivel: number = 0;
  estoqueBaixo: number = 0;
  estoqueZerado: number = 0;
  reservado: number = 0;
  todos: number = 0;
}
